export default {
    route: {
        title: "Mall",
        desc: "Quality selection quality service",
    },

    common: {
        category: "Category",
        subcategory: "Subcategory",
        all: "All",
        featured: "Recommended",
        search: "Please enter keywords",
        search_goods: "Search goods",
        keyword: "Keyword",
        reset_filter: "Reset filters",
        loading: "Loading...",
        no_more: "No more~",
        add_cart_success: "Add successfully",
        add_cart_fail: "Failed to add",
    },

    more: {
        favorites: "Favorites",
    },

    single: {
        all: "All",
        price: "Price",
        price_start: "up",
        stock: "Stock",
        stock_unit: "{num} pcs",
        deliver: "Deliver to",
        param: "Parameter",
        spec: "Specification",
        color: "Color",
        size: "Size",
        product: "Product",
        detail: "Detail",
        evaluate: "Evaluate",
        join_cart: "Add To Cart",
        buy: "Buy It Now",
        sold_out: "Unavailable",
        unavailable_tip: "This product is unavailable.",
        style: "Style Selection",
        select: "{num} models",
        fav: "Collect",
        service: "Service",
        cart: "Cart",
        address: "Select delivery address",
        addr_add: "Add new address",
        select_tip: "Please select specifications",
        restock_notice: "Notify Restock",
        restock_success: "Restock request submitted",
        restock_fail: "Failed to submit restock request",
        missing_title: "Product not found",
        missing_desc: "This product may have been removed, unpublished, or opened from an invalid link.",
        back_to_list: "Back to products",
    },

    cart: {
        title: "My cart",
        settlement: "Settlement",
        all: "All",
        del: "Delete",
        del_tip: "Remove this product?",
        total: "Total",
        edit: "Edit",
        success_tip: "The item has been added to the shopping cart successfully. Do you want to check out immediately?",
        confirm: "Go to checkout",
        cancel: "Continue shopping",
        select_tip: "Please select the product",
        empty: "No Data Available",
        item_count: "{count} items",
        selected_count: "{count} checkout-ready items selected",
        goods: "Product",
        variant: "Variant",
        unit_price: "Unit price",
        quantity: "Qty",
        subtotal: "Subtotal",
        stock_low: "Low stock",
        default_variant: "Default variant",
        unavailable: "Unavailable for checkout",
        goods_missing: "Product missing",
        goods_unavailable: "Product unavailable",
        variant_missing: "Variant missing",
        variant_unavailable: "Variant unavailable",
        insufficient_stock: "Insufficient stock",
        remove_invalid: "Remove unavailable items",
        remove_invalid_tip: "Remove all unavailable items?",
    },

    fav: {
        title: "My Favorites",
        empty: "No favorite products yet",
        saved_count: "{count} saved products",
        saved_hint: "Keep frequently viewed products here and confirm variants on the detail page.",
        page_range: "{start}-{end} / {total}",
        no_desc: "No product summary",
        view_detail: "View detail",
        close: "Close",
        remove_invalid: "Remove invalid products",
        remove_invalid_tip: "Remove all unavailable products from favorites?",
        remove_invalid_success: "{count} invalid products removed",
        invalid_count: "{count} invalid products",
        no_invalid_goods: "No invalid products",
        del_tip: "Remove this product?",
        del_success: "Removed successfully",
        del_fail: "Failed to remove",
        no_more: "No more products",
        add: "Add to Favorites",
        remove: "Remove from Favorites",
        add_success: "Added successfully",
        add_fail: "Failed to add",
        del: "Delete",
    },
};
